import React from 'react'
import { connect } from 'react-redux'
import { Table } from 'react-bootstrap'

import WorkloadTrackerRow from './WorkloadTrackerRow'

const WorkloadTrackerTable = (props) => {
  // POPULATE TABLE ROWS FOR PROJECT TIMESHEET
  let days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  let dayDates = []
  let dateHeaders = []

  days.forEach((day, index) => {
    let date = new Date(props.firstDay)
    // Create dates for each day of the current week
    date.setDate(date.getDate() + index)
    date = date.toLocaleDateString()
    dayDates.push(date)
    let dateToShow = date
    dateToShow = dateToShow.split("/")
    dateToShow.pop()
    dateToShow = dateToShow.join("/")
    // Create headers with days and dates of each day of the current week
    const dateHeader = (
      <td key={day + date} className="workload-table-date-header">
        {day}
        <br/>
        {dateToShow}
      </td>
    )
    dateHeaders.push(dateHeader)
  })

  // Sort selected projects
  let selectedProjects = [...props.selectedProjects]

  if (selectedProjects.length > 1) {
    selectedProjects = selectedProjects.sort((a, b) => {
      const projectA = `${a.short_id}-${a.number}-${a.title}`
      const projectB = `${b.short_id}-${b.number}-${b.title}`
      return projectA.localeCompare(projectB)
    })
  }

  // Create rows for each selected project
  let projectRows = selectedProjects.map((project, index) => {
    const totalHours = computeTotalRowHours(project, 'project', props)

    return (
      <WorkloadTrackerRow
        index={index}
        key={`${index}-${project.id}`}
        handleRemove={(project) => props.handleRemove(project, 'selectedProjects')}
        parentObject={project}
        parentObjectName={'project'}
        firstDay={props.firstDay}
        lastDay={props.lastDay}
        type={props.type}
        totalHours={totalHours}
        dayDates={dayDates}
        readOnly={props.readOnly}
      />
    )
  })

  // Create rows for each selected proposal
  let selectedProposals = [...props.selectedProposals]

  let proposalRows = selectedProposals.map((proposal, index) => {
    const totalHours = computeTotalRowHours(proposal, 'proposal', props)

    return (
      <WorkloadTrackerRow
        index={index}
        key={`${index}-${proposal.id}`}
        handleRemove={(proposal) => props.handleRemove(proposal, 'selectedProposals')}
        parentObject={proposal}
        parentObjectName={'proposal'}
        firstDay={props.firstDay}
        lastDay={props.lastDay}
        type={props.type}
        totalHours={totalHours}
        dayDates={dayDates}
        readOnly={props.readOnly}
      />
    )
  })

  let totalDayHours = 0
  let totalWeekHours = 0

  // Create tds to display the total hours for each day and the total hours of all projects for the week
  let hourTotals = dayDates.map(date => {
    totalDayHours = computeTotalDayHours(date, props)
    totalWeekHours += totalDayHours
    return (
      <td key={date} style={{borderRight:"thin solid #dcdbdc"}}>
        {totalDayHours}
      </td>
    )
  })

  const dailyTotal = (
    <td key="total" style={{borderRight:"thin solid #dcdbdc"}}>
      Daily Total
    </td>
  )

  const weeklyTotal = (
    <td key={totalWeekHours}>
      Total: {totalWeekHours}
    </td>
  )

  const hourTotalsForDispaly = (
    <tr
      key="total-hours"
      className={`total-${props.type}`}
      style={{textAlign:"center"}}
    >
      {[dailyTotal, ...hourTotals, weeklyTotal]}
    </tr>
  )

  const rowsForDisplay = [...projectRows, proposalRows, hourTotalsForDispaly]

  return (
    <Table responsive className="react-bs-table-bordered">
      <thead className={props.type}>
        <tr style={{textAlign:"center"}}>
          <td style={{textAlign:"left", verticalAlign:"middle",borderRight:"thin solid #dcdbdc"}}>
            Project
          </td>
          {dateHeaders}
          <td style={{verticalAlign:"middle", borderLeft:"thin solid #dcdbdc"}}>
            Project Total
          </td>
        </tr>
      </thead>
      <tbody>
        {rowsForDisplay}
      </tbody>
    </Table>
  )
}


const computeTotalRowHours = (element, elementType, props) => {
  // Get total hours for each project row
  let totalHours = 0
  const allSavedHours = [...props.projectHours, ...props.proposalHours]

  props.inputtedHours.forEach(hour => {
    if (hour[elementType] && hour[elementType].id === element.id && hour.type === props.type) {
      totalHours += Number(hour.hours)
    }
  })

  allSavedHours.forEach(savedHour => {

    const foundInputHour = props.inputtedHours.find(inputHour => {
      const savedHourDate = new Date(savedHour.date.replace(/-/g, "/")).toLocaleDateString()

      return !!inputHour[elementType] && inputHour[elementType].id === element.id && inputHour.type === savedHour.type && inputHour.date === savedHourDate
    })

    if (!foundInputHour && savedHour[elementType] && savedHour[elementType].id === element.id && savedHour.type === props.type) {
      totalHours += Number(savedHour.hours)
    }
  })

  return totalHours
}

const computeTotalDayHours = (date, props) => {
  // Get total hours for each day's column
  let totalHours = 0

  const dayDate = new Date(date.replace(/-/g, "/")).toLocaleDateString()

  props.inputtedHours.forEach(hour => {
    const hourDate = new Date(hour.date.replace(/-/g, "/")).toLocaleDateString()

    if (dayDate === hourDate && hour.type === props.type) {
      totalHours += Number(hour.hours)
    }
  })

  props.projectHours.forEach(projectHour => {
    const hourDate = new Date(projectHour.date.replace(/-/g, "/")).toLocaleDateString()

    const foundInputHour = props.inputtedHours.find(inputHour => {
      return inputHour.date === hourDate && !!inputHour.project && inputHour.project.id === projectHour.project.id
    })

    if (!foundInputHour && dayDate === hourDate && projectHour.type === props.type) {
      totalHours += Number(projectHour.hours)
    }
  })

  props.proposalHours.forEach(proposalHour => {
    const hourDate = new Date(proposalHour.date.replace(/-/g, "/")).toLocaleDateString()

    const foundInputHour = props.inputtedHours.find(inputHour => {
      return inputHour.date === hourDate && !!inputHour.proposal && inputHour.proposal.id === proposalHour.proposal.id
    })

    if (!foundInputHour && dayDate === hourDate && proposalHour.type === props.type) {
      totalHours += Number(proposalHour.hours)
    }
  })

  return totalHours
}

const mapStateToProps = (state) => {
  return {
    projectHours: state.manageHours.projectHours,
    proposalHours: state.manageHours.proposalHours,
    inputtedHours: state.manageHours.inputtedHours,
  }
}


export default connect(mapStateToProps)(WorkloadTrackerTable)



// WEBPACK FOOTER //
// ./src/routes/workload/components/WorkloadTrackerTable.js